import { render, staticRenderFns } from "./SmQuestionnaireIcon.vue?vue&type=template&id=75657b52&scoped=true&"
var script = {}
import style0 from "./SmQuestionnaireIcon.vue?vue&type=style&index=0&id=75657b52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75657b52",
  null
  
)

export default component.exports